/**
 * The catalogue was seeded with stock photography (Unsplash, the old build
 * tool's CDN). A stock photo shown as our product misrepresents it, so we
 * only use images the team uploaded; everything else falls back to the
 * illustrated jar.
 */
const STOCK_HOSTS = ["images.unsplash.com", "unsplash.com", "emergentagent.com", "emergent.sh", "pexels.com"];

export function isStockImage(url) {
  if (!url) return true;
  try {
    const host = new URL(url, window.location.origin).hostname;
    return STOCK_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
  } catch {
    return true;
  }
}

export function realGallery(product) {
  return (product?.gallery || []).filter((u) => !isStockImage(u));
}
